function debounce(fn, delay) {
  let timer = null;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}

// 自定义：Chat Widget 滚动显示控制
function initChatWidgetScrollControl() {
  const widgetSelector = "#chat-widget-minimized";

  // [新增] 防止重复初始化：如果之前已经存在控制器，先清理
  if (window.chatWidgetScrollController) {
    try {
      window.chatWidgetScrollController.disconnect();
    } catch (e) {
      console.warn("Failed to disconnect previous chat widget controller", e);
    }
  }

  // 核心逻辑：根据滚动高度控制显示/隐藏
  const updateVisibility = () => {
    const widget = document.querySelector(widgetSelector);
    if (!widget) return;

    if (window.pageYOffset < 380) {
      // 使用 setProperty 以正确应用 !important
      widget.style.setProperty("display", "none", "important");
    } else {
      widget.style.display = "";
    }
  };

  // (1) 初始执行
  updateVisibility();

  // (2) 监听滚动
  window.addEventListener("scroll", updateVisibility);

  // (3) 监听DOM变化（处理动态加载）
  const observer = new MutationObserver((mutations) => {
    // 简单检查：如果组件存在，就尝试更新状态
    // 这样可以覆盖组件刚加载出来时的默认状态
    if (document.querySelector(widgetSelector)) {
      updateVisibility();
    }
  });

  // 监听 body 的子元素变化
  observer.observe(document.body, {
    childList: true,
    subtree: true // 因为不确定插件会插入到哪里，开启subtree
  });

  // [新增] 保存清理方法到全局对象，以便后续清理或防止重复绑定
  window.chatWidgetScrollController = {
    disconnect: () => {
      window.removeEventListener("scroll", updateVisibility);
      observer.disconnect();
      window.chatWidgetScrollController = null;
    }
  };
}

// 仅当手机端的时候调用这个方法
if (window.matchMedia("(max-width: 767px)").matches) {
  initChatWidgetScrollControl();
}

//自定义：to top悬浮按钮
class BackToTopButton extends HTMLElement {
  constructor() {
    super()
    this.handleScroll = this.handleScroll.bind(this)
    this.addEventListener("click", () => {
      window.scrollTo({ top: 0, behavior: "smooth" })
    })
  }

  connectedCallback() {
    window.addEventListener("scroll", this.handleScroll)
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.handleScroll)
  }

  handleScroll() {
    const viewportHeight = window.innerHeight
    const scrollPosition = window.scrollY || document.documentElement.scrollTop
    if (scrollPosition > viewportHeight + 280) {
      this.classList.add("show")
    } else {
      this.classList.remove("show")
    }
  }
}

if (!window.customElements.get("back-to-top-button")) {
  customElements.define("back-to-top-button", BackToTopButton)
}

//自定义：产品页附加产品功能
class AdditionalProducts extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.registerClickEvents()
    this.jointName() //默认先展示一次None
  }
  registerClickEvents() {
    this.querySelectorAll(".product-block-wrap").forEach((item) => {
      item.addEventListener("click", () => {
        if (item.classList.contains("active")) {
          item.classList.remove("active")
        } else {
          item.classList.add("active")
        }
        this.jointName()
      })
    })
  }
  jointName() {
    const allActiveWraps = this.querySelectorAll(".product-block-wrap.active")
    const optionValue = this.querySelector(".option-value")
    let jointText = Array.from(allActiveWraps).reduce((prev, item) => {
      const title = item.querySelector(".title").innerText + " / "
      return (prev += title)
    }, "")
    if (jointText.length > 0) {
      jointText = jointText.slice(0, -3)
    }
    optionValue.innerText = jointText || "None"
  }
}

if (!window.customElements.get("additional-products")) {
  customElements.define("additional-products", AdditionalProducts)
}

//自定义：判断pc还是h5的按钮功能
class CustomAElement extends HTMLElement {
  constructor() {
    super()
    this.addEventListener("click", this.handleClick)
  }

  handleClick(event) {
    event.preventDefault() // 阻止默认跳转行为

    const appleUrl = this.getAttribute("apple-url")
    const androidUrl = this.getAttribute("android-url")

    // 判断设备是否为手机
    const isMobile = window.matchMedia("(max-width: 767px)").matches

    // 判断是否为苹果设备或安卓设备
    const isAppleDevice = /iPhone|iPad|iPod|Macintosh/.test(navigator.userAgent)

    if (isMobile) {
      // 手机设备逻辑
      if (isAppleDevice && appleUrl) {
        window.location.href = appleUrl
      } else {
        window.location.href = androidUrl
      }
    } else {
      // 电脑设备逻辑
      const isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0

      if (isMac && appleUrl) {
        window.location.href = appleUrl
      } else {
        window.location.href = androidUrl
      }
    }
  }
}

// 注册自定义元素
if (!window.customElements.get("custom-a")) {
  customElements.define("custom-a", CustomAElement)
}

//自定义：comparison table，点击按钮
/* 
参数：
white-modal-id：white-modal的id，等于white-modal.liquid的modal_type参数
pc-modal-id：pc-modal的id，等于pc-modal.liquid的modal_type参数
white-modal-height-factor：white-modal的高度因子，通常是0 - 1之间的小数

inner-id: 如果是多个内容共用弹窗的话，那具体展示哪个内容，需要通过此id指定
*/
class dialogButton extends HTMLElement {
  constructor() {
    super()
    // 绑定this
    this.initPhoneWhiteModal = this.initPhoneWhiteModal.bind(this)
    this.commonModal = this.hasAttribute("common-modal")
    if(this.commonModal) {
      this.h5CommonModalShowDom = document.querySelector(`.white-modal #${this.getAttribute("inner-id")}`)
      this.pcCommonModalShowDom = document.querySelector(`pc-modal #${this.getAttribute("inner-id")}`)
    } else {
      this.h5CommonModalShowDom = document.querySelector("#h5-comparison-modal")
    }

    this.whiteModalId = this.getAttribute("white-modal-id")
    this.pcModalId = this.getAttribute("pc-modal-id")
    this.whiteModalHeightFactor = parseFloat(this.getAttribute("white-modal-height-factor")) || 0.15

    // 缓存DOM元素，避免重复查询
    this.modal = document.querySelector(`#${this.whiteModalId}`)
    this.modalContent = this.modal.querySelector(".white-modal-content")
    this.modalInner = this.modal.querySelector(".white-modal-inner")

    // 业务逻辑
    this.addEventListener("click", this.handleClick)
    this.initPhoneWhiteModal()
  }
  
  initPhoneWhiteModal() {
    const _this = this
    this.modal.addEventListener("click", function (event) {
      // 检查点击是否在 .white-modal-content 区域之外
      if (!event.target.closest(".white-modal-content") || event.target.closest(".white-modal-close")) {
        _this.closePhoneWhiteModal()
      }
    })
    this.modalContent.addEventListener("scroll", function (event) {
      event.stopPropagation()
      if (event.cancelable) {
        event.preventDefault()
      }
    })
  }

  handleClick() {
    // 判断设备是否为手机
    const isMobile = window.matchMedia("(max-width: 767px)").matches
    if (isMobile) {
      this.openPhoneWhiteModal()
      document.body.style.overflow = 'hidden';
    } else {
      this.openPcModal()
    }
  }
  openPcModal() {
    this.listenPcModalClose()
    const pcModal = document.querySelector(`#${this.pcModalId}`)
    if(this.commonModal) {
      this.pcCommonModalShowDom.classList.remove("hidden")
    }
    if (pcModal) {
      pcModal.style.display = "block"
    }
  }
  listenPcModalClose() {
    document.addEventListener("dialog:close", (info)=>{
      console.log("info.detail.dialogType:",info.detail.dialogType)
      if(info.detail.dialogType == this.getAttribute("pc-modal-type")){
        this.pcCommonModalShowDom.classList.add("hidden")
      }
    })
  }
  openPhoneWhiteModal() {
    if(this.commonModal) {
      this.h5CommonModalShowDom.classList.remove("hidden")
    }
    this.modal.style.display = "block"

    setTimeout(() => {
      // 计算顶部位置
      let viewportHeight = window.innerHeight
      let modalTopAttrValue = viewportHeight * this.whiteModalHeightFactor
      // 应用计算后的顶部位置
      this.modalContent.style.top = modalTopAttrValue + "px"
    }, 10) // 小的超时来触发过渡
  }

  closePhoneWhiteModal() {
    document.body.style.overflow = "unset";
    this.modalContent.style.top = "100%"
    setTimeout(() => {
      this.h5CommonModalShowDom.classList.add("hidden")
      this.modal.style.display = "none"
    }, 300) // 与CSS过渡时间匹配
  }
}

// 注册自定义元素
if (!window.customElements.get("dialog-button")) {
  customElements.define("dialog-button", dialogButton)
}

class PcModal extends HTMLElement {
  constructor() {
    super()
    this._modal = this.querySelector(".modal-content")
    this.modalType = this.getAttribute("modal-type")
    this._closeButton = this.querySelector(".close")
    // 打开和关闭模态框的功能
    this.open = this.open.bind(this)
    this.close = this.close.bind(this)

    // 监听关闭按钮的点击事件
    if (this._closeButton) {
      this._closeButton.addEventListener("click", this.close)
    }

    // 监听点击模态框外部时关闭模态框
    this.addEventListener("click", (event) => {
      if (event.target === this) {
        this.close()
      }
    })
  }

  // 打开模态框
  open() {
    this.style.display = "block"
    this._modal.classList.remove("modal-hide")
  }

  // 关闭模态框
  close() {
    if(this.modalType){
      const event = new CustomEvent("dialog:close",{
        detail: {
          dialogType: this.modalType
        },
      })
      document.dispatchEvent(event) // 触发事件
    }
    this.style.display = "none"
  }
}
if (!window.customElements.get("pc-modal")) {
  // 定义自定义元素
  customElements.define("pc-modal", PcModal)
}

/* media-compose-marquee中用到了video，该组件开启自动播放 */
class videoBesideMaquee extends HTMLElement {
  constructor() {
    super()
    setTimeout(() => {
      this._playVideo()
    }, 0);
  }
  _playVideo(){
    this.videoMedia = this.querySelector("video-media")
    this.videoMedia.play({ restart: true });
  }
}
if (!window.customElements.get("video-beside-maquee")) {
  // 定义自定义元素
  customElements.define("video-beside-maquee", videoBesideMaquee)
}

// js/development/sliderTabs.js
import { animate as animate50 } from "vendor";
var sliderTabs = class extends HTMLElement {
  static get observedAttributes() {
    return ["selected-index"];
  }
  constructor() {
    super();
    this.slider = this.querySelector(".slider");
    if (!this.shadowRoot) {
      this.attachShadow({ mode: "open" }).appendChild(this.querySelector("template").content.cloneNode(true));
    }
    if (Shopify.designMode) {
      this.addEventListener("shopify:block:select", (event) => this.selectedIndex = this.buttons.indexOf(event.target));
    }
    this.addEventListener("keydown", this._handleKeyboard);
    document.addEventListener("swiperOfSliderTabs:change", debounce(this._changeTabByIndex.bind(this), 300));
  }
  connectedCallback() {
    this._abortController = new AbortController();
    this.buttons = Array.from(this.shadowRoot.querySelector('slot[name="title"]').assignedNodes(), (item) => item.matches("button") && item || item.querySelector("button"));
    this.panels = Array.from(this.shadowRoot.querySelector('slot[name="content"]').assignedNodes());
    this.buttons.forEach((button, index) => button.addEventListener("click", () => {
      this.selectedIndex = index
      const event = new CustomEvent("sliderTabs:change", {
        detail: {
          index: index,
        },
      })
      document.dispatchEvent(event) // 触发事件
    }, { signal: this._abortController.signal }));
    this.selectedIndex = this.selectedIndex;
    this._setupAccessibility();
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  get animationDuration() {
    return this.hasAttribute("animation-duration") ? parseFloat(this.getAttribute("animation-duration")) : 0.15;
  }
  get selectedIndex() {
    return parseInt(this.getAttribute("selected-index")) || 0;
  }
  set selectedIndex(index) {
    this.setAttribute("selected-index", Math.min(Math.max(index, 0), this.buttons.length - 1).toString());
    this.style.setProperty("--selected-index", this.selectedIndex.toString());
    this.style.setProperty("--item-count", this.buttons.length.toString());
  }
  attributeChangedCallback(name, oldValue, newValue) {
    this.buttons.forEach((button, index) => button.setAttribute("aria-selected", index === parseInt(newValue) ? "true" : "false"));
    if (name === "selected-index" && oldValue !== null && oldValue !== newValue) {
      this._transitionTab(this.slider, parseInt(newValue));
      this._transitionContent(this.panels[parseInt(oldValue)], this.panels[parseInt(newValue)]);
    }
  }
  _setupAccessibility() {
    const componentID = crypto.randomUUID ? crypto.randomUUID() : Math.floor(Math.random() * 1e4);
    this.buttons.forEach((button, index) => {
      button.setAttribute("role", "tab");
      button.setAttribute("aria-controls", `tab-panel-${componentID}-${index}`);
      button.id = `tab-${componentID}-${index}`;
    });
    this.panels.forEach((panel, index) => {
      panel.setAttribute("role", "tabpanel");
      panel.setAttribute("aria-labelledby", `tab-${componentID}-${index}`);
      panel.id = `tab-panel-${componentID}-${index}`;
      panel.hidden = index !== this.selectedIndex;
    });
  }
  _changeTabByIndex(event) {
    const index = event.detail.index;
    if (index >= 0 && index < this.buttons.length) {
      this.selectedIndex = index;
    }
  }
  /**
   * As per https://www.w3.org/WAI/ARIA/apg/example-index/tabs/tabs-automatic.html, when a tab is currently focused,
   * left and right arrow should switch the tab
   */
  _handleKeyboard(event) {
    const index = this.buttons.indexOf(document.activeElement);
    if (index === -1 || !["ArrowLeft", "ArrowRight"].includes(event.key)) {
      return;
    }
    if (event.key === "ArrowLeft") {
      this.selectedIndex = (this.selectedIndex - 1 + this.buttons.length) % this.buttons.length;
    } else {
      this.selectedIndex = (this.selectedIndex + 1 + this.buttons.length) % this.buttons.length;
    }
    this.buttons[this.selectedIndex].focus();
  }
  /**
   * Perform a custom transition (can be overridden in subclasses). To "from" and "to" are hash representing the panel
   */
  async _transitionTab(slider, toIndex) {
    await animate50(slider, { x: `${toIndex * 100}%` }, { duration: 0.3, easing: "ease-in-out" }).finished;
  }
  async _transitionContent(fromPanel, toPanel) {
    await animate50(fromPanel, { opacity: [1, 0] }, { duration: this.animationDuration }).finished;
    fromPanel.hidden = true;
    toPanel.hidden = false;
    await animate50(toPanel, { opacity: [0, 1] }, { duration: this.animationDuration }).finished;
  }
};
if (!window.customElements.get("slider-tabs")) {
  window.customElements.define("slider-tabs", sliderTabs);
}

// js/development/sliderTabsPcCarousel.js
// 将轮播图抽到单独的组件中【其实就应该这样抽，但是代码当中有一些是<script></script>去弄的】
var sliderTabsPcCarousel = class extends HTMLElement {
  constructor() {
    super();
    this.actualSlideNum = parseInt(this.getAttribute("actual-slide-num"));
    this.stretchValue = parseInt(this.getAttribute("stretch-value")) || -120
    document.addEventListener("sliderTabs:change", this._changeSlideByIndex.bind(this));
    if(!window.matchMedia("(max-width: 767px)").matches) {
      this.targetSwiper = this._initPcSwiper();
      this._listenSwiperChange(this.targetSwiper);
    }
  }
  _initPcSwiper() {
    const targetDom = this.querySelector(".swiper-container");
    if(!targetDom) return null;
    return new Swiper(targetDom, {
      effect: 'coverflow',
      centeredSlides: true,
      slidesPerView: 1.5, // ✅ 显示1.5个slide，两边各漏一点
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      coverflowEffect: {
        rotate: 0,
        stretch: this.stretchValue, // ✅ 负值让两侧图片稍微收缩
        depth: 800,
        modifier: 1,
        slideShadows: true, // ✅ 关闭阴影，按需调整
      },
    });
  }
  _listenSwiperChange(targetSwiper) {
    const tempActualSlideNum = this.actualSlideNum
    targetSwiper.on('realIndexChange', function () {
      const event = new CustomEvent("swiperOfSliderTabs:change", {
        detail: { //因为swiper在3个slide的时候，存在bug时，所以liquid中处理了代码，同时这里也要处理。
          index: tempActualSlideNum > 3 ? targetSwiper.realIndex : (targetSwiper.realIndex % tempActualSlideNum),
        },
      });
      document.dispatchEvent(event); // 触发事件
    });
  }
  _changeSlideByIndex(event) {
    const index = event.detail.index;
    if(this.targetSwiper) {
      this.targetSwiper.slideToLoop(index);
    }
  }
}
if (!window.customElements.get("slider-tabs-pc-carousel")) {
  window.customElements.define("slider-tabs-pc-carousel", sliderTabsPcCarousel);
}

// js/development/pcH5Carousel.js
// h5-show-num：一屏展示多少张图片
// h5-picture-gap：图片间距
// carousel-speed：轮播速度
var pcH5Carousel = class extends HTMLElement {
  constructor() {
    super();
    if(window.matchMedia("(max-width: 767px)").matches) {
      this._initH5Swiper();
    } else {
      this._initPcSwiper();
    }
  }
  _initH5Swiper() {
    const h5CarouselDom = this.querySelector('.h5-swiper-container');
    if (!h5CarouselDom) return;

    // 获取属性值并设置默认值
    const slidesPerView = parseFloat(this.getAttribute('h5-show-num')) || 1;
    const spaceBetween = parseInt(this.getAttribute('h5-picture-gap')) || 0;
    const carouselSpeed = parseInt(this.getAttribute('carousel-speed')) || 0;

    // 基础配置
    const config = {
      slidesPerView: slidesPerView,
      spaceBetween: spaceBetween,
      loop: true,
      grabCursor: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    };

    // 处理自动轮播
    if (carouselSpeed !== 0) {
      config.autoplay = {
        delay: carouselSpeed * 1000,
        disableOnInteraction: false,
      };
    }

    // 初始化 Swiper
    new Swiper(h5CarouselDom, config);
  }
  _initPcSwiper() {
    const pcCarouselDom = this.querySelector('.swiper-container');
    if (!pcCarouselDom) return;

    const carouselSpeed = parseInt(this.getAttribute('carousel-speed')) || 0;

    const config = {
      effect: "coverflow",
      grabCursor: true,
      centeredSlides: true,
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 300,
        modifier: 1,
        slideShadows: true,
      },
      breakpoints: {
        767: {
          slidesPerView: 3,
          loop: false,
          coverflowEffect: {
            rotate: 0,
            depth: 100,
            slideShadows: false,
          },
        },
        768: {
          slidesPerView: "auto",
          loop: true,
          coverflowEffect: {
            rotate: 0,
            depth: 300,
            slideShadows: true,
          },
        },
      },
    };

    if (carouselSpeed !== 0) {
      config.autoplay = {
        delay: carouselSpeed * 1000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    new Swiper(pcCarouselDom, config);
  }
}

if (!window.customElements.get("pc-h5-carousel")) {
  window.customElements.define("pc-h5-carousel", pcH5Carousel);
}

class AnimationText extends HTMLElement {
  constructor() {
    super();
    this.from = 0; // 默认起始值
    this.currentValue = 0;
    this.hasAnimated = false; // 跟踪动画是否已经播放过
    this.observer = null;
    this.originalText = ''; // 存储原始文本以分析格式
    this.decimalPlaces = 0; // 存储小数位数
  }

  connectedCallback() {
    // 保存原始文本
    this.originalText = this.textContent.trim();
    
    // 获取目标值
    this.to = parseFloat(this.originalText);

    if (isNaN(this.to)) {
      return;
    }

    this.duration = parseFloat(this.getAttribute('duration')) || 1.0;
    
    // 设置起始值（从0开始或者目标值的一小部分）
    this.from = this.to > 100 ? this.to * 0.5 : 0;
    
    // 分析原始数字的小数位数
    this.analyzeDecimalPlaces();
    
    // 初始显示起始值
    this.updateNumber(this.from);
    
    // 使用 IntersectionObserver 监视元素是否进入视口
    this.setupIntersectionObserver();
  }

  // 分析原始数字的小数位数
  analyzeDecimalPlaces() {
    const parts = this.originalText.split('.');
    if (parts.length > 1) {
      this.decimalPlaces = parts[1].length;
    } else {
      this.decimalPlaces = 0;
    }
  }

  setupIntersectionObserver() {
    this.observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      
      // 当元素进入视口且动画尚未播放时开始动画
      if (entry.isIntersecting && !this.hasAnimated) {
        setTimeout(() => {
          this.animateNumberChange(this.from, this.to);
          this.hasAnimated = true;
        }, 600);
      }
    }, {
      threshold: 0.1 // 当元素有10%进入视口时触发
    });
    
    this.observer.observe(this);
  }

  // 缓动函数 - 指数减速
  easeOutExpo(x) {
    return x === 1 ? 1 : 1 - Math.pow(2, -10 * x);
  }

  // 更新显示的数字，保持与原始输入相同的小数位数
  updateNumber(value) {
    this.currentValue = value;
    // 使用分析出的小数位数格式化数字
    this.textContent = value.toFixed(this.decimalPlaces);
  }

  async animateNumberChange(from, to) {
    if (!window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
      // 如果用户偏好减少动画，则直接显示最终结果而不进行动画
      this.updateNumber(to);
      return;
    }
    
    const duration = this.duration; // 动画持续时间，单位秒
    const startTime = performance.now();
    
    const animate = (currentTime) => {
      const elapsed = (currentTime - startTime) / 1000; // 转换为秒
      const progress = Math.min(elapsed / duration, 1);
      const easedProgress = this.easeOutExpo(progress);
      const currentValue = from + (to - from) * easedProgress;
      
      this.updateNumber(currentValue);
      
      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };
    
    requestAnimationFrame(animate);
  }

  disconnectedCallback() {
    // 清理观察器以防止内存泄漏
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}

// 注册自定义元素
if (!window.customElements.get("animation-text")) {
  customElements.define("animation-text", AnimationText);
}

// 左侧菜单切换右侧内容的自定义元素
class leftSwitchMegaMenu extends HTMLElement {
  constructor() {
    super();
    this.triggerType = this.getAttribute('trigger-type') || 'click';
    this.init();
  }

  init() {
    // 获取所有左侧菜单项
    this.menuItems = this.querySelectorAll('.left-menu-item');
    // 获取所有右侧面板
    this.panels = this.querySelectorAll('.second-third-level-panel');
    
    // 根据触发类型添加不同的事件监听
    if (this.triggerType === 'hover') {
      this.menuItems.forEach(item => {
        item.addEventListener('mouseenter', this.handleMenuItemClick.bind(this, item));
      });
    } else {
      this.menuItems.forEach(item => {
        item.addEventListener('click', this.handleMenuItemClick.bind(this, item));
      });
    }
  }

  handleMenuItemClick(clickedItem) {
    // 获取点击的菜单项索引
    const index = clickedItem.dataset.index;
    
    // 移除所有菜单项的active类
    this.menuItems.forEach(item => {
      item.classList.remove('active');
    });
    
    // 为点击的菜单项添加active类
    clickedItem.classList.add('active');
    
    // 隐藏所有面板
    this.panels.forEach(panel => {
      panel.classList.remove('active');
    });
    
    // 显示对应的面板
    const targetPanel = this.querySelector(`.second-third-level-panel[data-panel-index="${index}"]`);
    if (targetPanel) {
      targetPanel.classList.add('active');
      
      // 添加动画效果
      this.animatePanelChange(targetPanel);
    }
  }
  
  animatePanelChange(panel) {
    // 为面板添加简单的淡入效果
    panel.style.opacity = '0';
    panel.style.transform = 'translateY(10px)';
    
    // 使用requestAnimationFrame确保DOM更新后再应用动画
    requestAnimationFrame(() => {
      panel.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
      panel.style.opacity = '1';
      panel.style.transform = 'translateY(0)';
      
      // 清除过渡效果，以便下次切换
      setTimeout(() => {
        panel.style.transition = '';
      }, 300);
    });
  }
}

if (!window.customElements.get('left-switch-mega-menu')) {
  customElements.define('left-switch-mega-menu', leftSwitchMegaMenu);
}

// 左侧菜单切换右侧内容的自定义元素
class localizationSelector extends HTMLElement {

  /**
   * Helper function to get a cookie by name.
   * @param {string} name The name of the cookie.
   * @returns {string|null} The cookie value or null if not found.
   */
  _getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }
  
  /**
   * Helper function to set a cookie.
   * @param {string} name The name of the cookie.
   * @param {string} value The value of the cookie.
   * @param {number} [days=7] The number of days until the cookie expires.
   */
  _setCookie(name, value, days = 7) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    // Set path=/ to make the cookie available site-wide
    document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=Lax";
  }

  /**
   * Checks if the affiliate tracking ID exists in the URL query string.
   * If it does, store it in our own cookie for immediate access.
   */
  handleUrlQueryToCookie() {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const imRefValue = urlParams.get('im_ref');

      if (imRefValue) {
        console.log(`Found 'im_ref' in URL, setting 'selfhandle_irclickid' cookie.`);
        this._setCookie('selfhandle_irclickid', imRefValue);
      }
    } catch (e) {
      console.error("Error processing URL parameters:", e);
    }
  }

  /**
   * Called when the element is added to the DOM.
   */
  connectedCallback() {
    // 1. 立即检查URL参数并设置我们自己的cookie
    this.handleUrlQueryToCookie();

    // 2. 开始轮询，以寻找我们自己的cookie或第三方设置的cookie
    this._pollForAffiliateId();
  }

  /**
   * Polls for either 'selfhandle_irclickid' or 'irclickid' cookie.
   */
  _pollForAffiliateId() {
    const pollInterval = 100; // Check every 100ms
    const maxDuration = 6000; // Stop after 6 seconds
    const startTime = Date.now();

    const intervalId = setInterval(() => {
      // 检查我们自己设置的cookie或第三方设置的cookie
      const selfHandledId = this._getCookie('selfhandle_irclickid');
      const thirdPartyId = this._getCookie('irclickid');
      
      const finalId = selfHandledId || thirdPartyId;

      // --- Success Condition ---
      // 如果任意一个cookie存在，则停止轮询并重写链接
      if (finalId) {
        clearInterval(intervalId);
        console.log(`Affiliate ID found: ${finalId}. Ceasing poll.`);
        this._rewriteLinks(finalId);
        return;
      }

      // --- Timeout Condition ---
      // 如果6秒已过，则停止轮询
      if (Date.now() - startTime > maxDuration) {
        clearInterval(intervalId);
        console.warn('Polling for affiliate ID timed out after 6 seconds.');
      }
    }, pollInterval);
  }

  /**
   * Rewrites the links with the affiliate tracking parameter.
   * @param {string} affiliateId The affiliate ID found.
   */
  _rewriteLinks(affiliateId) {
    const urlsToRewrite = [
      'https://ca.deerruntreadmill.com',
      'https://eu.deerruntreadmill.com',
    ];

    this.querySelectorAll('.popover-listbox__option').forEach(link => {
      try {
        if (link.href && (link.href.startsWith('http:') || link.href.startsWith('https://'))) {
          const url = new URL(link.href);
          if (urlsToRewrite.includes(url.origin)) {
            url.searchParams.set('im_ref', affiliateId);
            link.href = url.toString();
          }
        }
      } catch (e) {
        console.error(`Invalid URL for localization selector: ${link.href}`, e);
      }
    });
  }
}

// 确保自定义元素被定义
if (!customElements.get('localization-selector')) {
  customElements.define('localization-selector', localizationSelector);
}

// 新的附加产品组件
class NewAdditionalProducts extends HTMLElement {
  constructor() {
    super();
    this.selectedProducts = new Set(); // 存储选中的产品ID
    this.isExpanded = false; // 展开状态
    this.collapsedMaxHeight = null; // 收起时的最大高度
  }

  connectedCallback() {
    this.init();
    
    // 延迟检查溢出状态，确保DOM完全渲染
    setTimeout(() => {
      this.checkOverflowAndGradient();
      this.checkExpandCollapseNeeded();
    }, 100);
    
    // 监听窗口大小变化，重新检查溢出状态
    this.resizeObserver = new ResizeObserver(() => {
      this.checkOverflowAndGradient();
      this.checkExpandCollapseNeeded();
    });
    this.resizeObserver.observe(this);
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  init() {
    // 为每个产品项绑定点击事件
    this.querySelectorAll('.new-additional-product-item').forEach(item => {
      this.setupProductItem(item);
    });
    
    // 为展开/收起按钮绑定点击事件
    this.setupExpandCollapseButton();
    // 为Shuffle按钮绑定点击事件
    this.setupShuffleButton();
  }
  
  setupExpandCollapseButton() {
    const wrapper = this.closest('.new-additional-products-wrapper');
    if (!wrapper) return;
    
    const expandBtn = wrapper.querySelector('.expand-collapse-btn');
    if (!expandBtn) return;
    
    expandBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      this.toggleExpandCollapse();
    });
  }

  setupShuffleButton() {
    const wrapper = this.closest('.new-additional-products-wrapper');
    if (!wrapper) return;
    const shuffleBtn = wrapper.querySelector('.shuffle-btn');
    if (!shuffleBtn) return;

    shuffleBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      this.handleShuffle(shuffleBtn);
    });
  }

  async handleShuffle(btn) {
    if (this.isShuffling) return;
    this.isShuffling = true;
    btn.classList.add('rotating');

    try {
      this.shuffleProducts();
    } catch (e) {
      console.error('Shuffle error:', e);
    }

    setTimeout(() => {
      btn.classList.remove('rotating');
      this.isShuffling = false;
    }, 500);
  }

  shuffleProducts() {
    const container = this.closest('.new-additional-products-container');
    if (!container) return;
    
    const poolScript = container.querySelector('.nap-data-pool');
    if (!poolScript) return;
    
    let poolData;
    try {
      poolData = JSON.parse(poolScript.textContent);
    } catch(e) {
      return;
    }

    const allProducts = poolData.products || [];
    const iconMap = poolData.icon_map || {};
    
    // 获取当前页面上存在的产品ID（包括选中的和未选中的）
    const currentItems = Array.from(this.querySelectorAll('.new-additional-product-item'));
    const currentIds = new Set();
    currentItems.forEach(item => {
      const data = this.getProductData(item);
      if (data && data.id) currentIds.add(data.id);
    });
    
    // 筛选出未选中的DOM元素（即需要被替换的位置）
    const candidates = currentItems.filter(item => !item.classList.contains('selected'));
    if (candidates.length === 0) return;

    // 从池子中筛选出不在当前页面上的产品
    const available = allProducts.filter(p => !currentIds.has(p.id));
    if (available.length === 0) return;

    // 加权随机打乱 (带有图标的产品权重更高)
    const shuffled = available.map(p => {
      // 检查是否有图标
      const hasIcon = !!iconMap[String(p.id)];
      // 权重: 有图标 1.3 (提升30%), 无图标 1.0
      const weight = hasIcon ? 30 : 1.0;
      // 使用加权随机分数 (Weighted Random Score)
      const score = Math.pow(Math.random(), 1 / weight);
      return { product: p, score: score };
    })
    .sort((a, b) => b.score - a.score)
    .map(item => item.product);

    // 替换逻辑
    candidates.forEach((item, index) => {
      if (index < shuffled.length) {
        this.replaceProductItem(item, shuffled[index], iconMap);
      }
    });
  }

  replaceProductItem(item, product, iconMap) {
    // 1. 更新 data-product-handle
    item.setAttribute('data-product-handle', product.handle);

    // 2. 更新 Corner Icon
    let cornerIcon = item.querySelector('.product-corner-icon');
    const iconUrl = iconMap[String(product.id)]; // Key is string in JSON
    
    if (iconUrl) {
      if (!cornerIcon) {
        cornerIcon = document.createElement('div');
        cornerIcon.className = 'product-corner-icon';
        const img = document.createElement('img');
        img.width = 60;
        img.height = 60; 
        img.loading = 'lazy';
        cornerIcon.appendChild(img);
        item.appendChild(cornerIcon);
      }
      const img = cornerIcon.querySelector('img');
      if (img) img.src = iconUrl;
      cornerIcon.style.display = 'block';
    } else {
      if (cornerIcon) cornerIcon.style.display = 'none';
    }

    // 3. 更新主图
    const mainImg = item.querySelector('.product-image img');
    if (mainImg) {
      mainImg.src = product.featured_image;
      mainImg.alt = product.title;
    }

    // 4. 更新标题
    const titleEl = item.querySelector('.product-title');
    if (titleEl) {
      titleEl.textContent = product.title;
    }

    // 5. 更新变体选择器
    const variantContainer = item.querySelector('.product-variant-selector');
    if (product.variants && product.variants.length > 1) {
      if (!variantContainer) {
        // 如果之前没有容器，创建一个，插入到 title 后面
        const newContainer = document.createElement('div');
        newContainer.className = 'product-variant-selector';
        const infoDiv = item.querySelector('.new-additional-product-info');
        if (infoDiv) {
            if (titleEl) {
                 infoDiv.insertBefore(newContainer, titleEl.nextSibling);
            } else {
                 infoDiv.appendChild(newContainer);
            }
        }
      }
      
      // 重新获取容器
      const container = item.querySelector('.product-variant-selector');
      if (container) {
        container.innerHTML = ''; // 清空
        container.classList.remove('hidden');
        container.style.display = ''; // 清除可能存在的内联样式
        const select = document.createElement('select');
        select.className = 'variant-select';
        select.name = `variant-${product.id}`;
        
        product.variants.forEach(v => {
          const opt = document.createElement('option');
          opt.value = v.id;
          opt.dataset.price = v.price;
          opt.dataset.comparePrice = v.compare_at_price || '';
          opt.dataset.image = v.image || '';
          opt.textContent = v.title;
          if (v.id === product.variants[0].id) opt.selected = true;
          select.appendChild(opt);
        });
        
        container.appendChild(select);
        
        // 重新绑定事件
        select.addEventListener('change', (e) => {
          e.stopPropagation();
          this.handleVariantChange(item, e.target);
        });
      }
    } else {
      if (variantContainer) {
        variantContainer.classList.add('hidden');
        variantContainer.style.display = ''; // 清除可能存在的内联样式
      }
    }

    // 6. 更新价格
    const currentPriceEl = item.querySelector('.current-price');
    if (currentPriceEl) {
      currentPriceEl.textContent = '$' + this.formatPrice(product.price);
    }
    
    const comparePriceEl = item.querySelector('.compare-price');
    if (comparePriceEl) {
      if (product.compare_at_price && product.compare_at_price > product.price) {
        comparePriceEl.textContent = '$' + this.formatPrice(product.compare_at_price);
        comparePriceEl.style.display = 'inline';
      } else {
        comparePriceEl.style.display = 'none';
      }
    }

    // 7. 更新隐藏的数据 Script
    const scriptData = item.querySelector('.product-data');
    if (scriptData) {
      scriptData.textContent = JSON.stringify(product);
    }

    // 8. 确保状态为未选中
    item.classList.remove('selected');
    this.updateSelectButton(item, false);
    
    // 如果有变体，初始化显示
    if (product.variants && product.variants.length > 0) {
        const firstVariant = product.variants[0];
        const variantData = {
          id: firstVariant.id,
          price: firstVariant.price,
          comparePrice: firstVariant.compare_at_price,
          image: firstVariant.image
        };
        this.updateProductDisplay(item, variantData, product);
    }
  }
  
  checkExpandCollapseNeeded() {
    const items = this.querySelectorAll('.new-additional-product-item');
    const wrapper = this.closest('.new-additional-products-wrapper');
    if (!wrapper) return;
    
    const expandBtn = wrapper.querySelector('.expand-collapse-line');
    if (!expandBtn) return;
    
    // 如果产品数量 >= 4，则显示展开/收起按钮
    if (items.length >= 4) {
      this.style.paddingBottom = '30px';
      // 计算前3个产品的总高度
      this.calculateCollapsedHeight(items);
      
      // 显示按钮
      expandBtn.style.display = 'flex';
      
      // 初始状态为收起
      if (!this.isExpanded) {
        this.collapse();
      }
    } else {
      // 产品少于4个，隐藏按钮，移除高度限制
      expandBtn.style.display = 'none';
      this.style.maxHeight = 'none';
      wrapper.classList.remove('expanded');
    }
  }
  
  calculateCollapsedHeight(items) {
    // 计算前3个产品的总高度 + gap
    if (items.length < 3) return;
    
    let totalHeight = 0;
    const gap = 12; // gap between items
    
    for (let i = 0; i < 3; i++) {
      totalHeight += items[i].offsetHeight;
      if (i < 2) totalHeight += gap; // 添加gap，除了最后一个
    }
    
    // 添加padding-top
    totalHeight += 8;
    
    this.collapsedMaxHeight = totalHeight;
  }
  
  toggleExpandCollapse() {
    const wrapper = this.closest('.new-additional-products-wrapper');
    if (!wrapper) return;
    
    if (this.isExpanded) {
      this.collapse();
    } else {
      this.expand();
    }
  }
  
  collapse() {
    const wrapper = this.closest('.new-additional-products-wrapper');
    if (!wrapper) return;
    
    this.isExpanded = false;
    wrapper.classList.remove('expanded');
    
    // 设置最大高度为前3个产品的高度
    if (this.collapsedMaxHeight) {
      this.style.maxHeight = this.collapsedMaxHeight + 'px';
      this.style.overflow = 'hidden';
    }
  }
  
  expand() {
    const wrapper = this.closest('.new-additional-products-wrapper');
    if (!wrapper) return;
    
    this.isExpanded = true;
    wrapper.classList.add('expanded');
    
    // 移除高度限制
    this.style.maxHeight = 'none';
    this.style.overflow = 'hidden auto';
  }
  
  setupProductItem(item) {
    const selectBtn = item.querySelector('.product-select-btn');
    const variantSelect = item.querySelector('.variant-select');
    
    // 为整个产品项绑定点击事件
    item.addEventListener('click', (e) => {
      // 阻止点击选框和变体选择器时的默认行为
      if (e.target.closest('.product-select-btn') || e.target.closest('.variant-select')) {
        return;
      }
      this.toggleProductSelection(item);
    });

    // 为选择按钮绑定点击事件
    if (selectBtn) {
      selectBtn.addEventListener('click', (e) => {
        e.stopPropagation(); // 阻止冒泡到父元素
        this.toggleProductSelection(item);
      });
    }

    // 为变体选择器绑定变更事件
    if (variantSelect) {
      variantSelect.addEventListener('change', (e) => {
        e.stopPropagation(); // 阻止冒泡到父元素
        this.handleVariantChange(item, e.target);
      });
    }
  }

  toggleProductSelection(item) {
    const productData = this.getProductData(item);
    const isSelected = item.classList.contains('selected');
    
    if (isSelected) {
      // 取消选中
      item.classList.remove('selected');
      this.selectedProducts.delete(productData.id);
      this.updateSelectButton(item, false);
    } else {
      // 选中
      item.classList.add('selected');
      this.selectedProducts.add(productData.id);
      this.updateSelectButton(item, true);
    }

    // 触发自定义事件，通知其他组件
    this.dispatchEvent(new CustomEvent('selection-changed', {
      detail: {
        productId: productData.id,
        selected: !isSelected,
        selectedProducts: Array.from(this.selectedProducts)
      }
    }));

    // 重新检查是否需要显示渐变效果(表达可以往下滚动)
    setTimeout(() => {
      this.checkOverflowAndGradient();
    }, 0);
  }

  updateSelectButton(item, isSelected) {
    const unselectedIcon = item.querySelector('.unselected-icon');
    const selectedIcon = item.querySelector('.selected-icon');
    
    if (isSelected) {
      unselectedIcon.style.display = 'none';
      selectedIcon.style.display = 'block';
    } else {
      unselectedIcon.style.display = 'flex';
      selectedIcon.style.display = 'none';
    }
  }

  handleVariantChange(item, selectElement) {
    const selectedOption = selectElement.options[selectElement.selectedIndex];
    const productData = this.getProductData(item);
    
    // 获取变体数据
    const variantData = {
      id: selectedOption.value,
      price: selectedOption.dataset.price,
      comparePrice: selectedOption.dataset.comparePrice,
      image: selectedOption.dataset.image
    };

    // 更新产品显示信息
    this.updateProductDisplay(item, variantData, productData);
    
    // 触发变体变化事件，通知价格计算逻辑
    this.dispatchEvent(new CustomEvent('variant-changed', {
      detail: {
        productId: productData.id,
        variantId: variantData.id,
        variantData: variantData
      }
    }));
  }

  updateProductDisplay(item, variantData, productData) {
    // 更新图片
    const productImage = item.querySelector('.product-image img');
    if (productImage && variantData.image) {
      productImage.src = variantData.image;
    }

    // 更新价格
    const currentPriceElement = item.querySelector('.current-price');
    const comparePriceElement = item.querySelector('.compare-price');
    
    if (currentPriceElement) {
      const formattedPrice = this.formatPrice(variantData.price);
      currentPriceElement.textContent = `$${formattedPrice}`;
    }

    if (comparePriceElement) {
      const comparePrice = variantData.comparePrice;
      const price = variantData.price;
      
      // 检查 comparePrice 是否有效（不为 null、"null"、undefined 或空字符串）
      if (comparePrice && 
          comparePrice !== "null" && 
          comparePrice !== "" && 
          comparePrice !== null && 
          comparePrice !== "0" &&
          parseFloat(comparePrice) > 0 &&
          parseFloat(comparePrice) > parseFloat(price)) {
        const formattedComparePrice = this.formatPrice(comparePrice);
        comparePriceElement.textContent = `$${formattedComparePrice}`;
        comparePriceElement.style.display = 'inline';
      } else {
        comparePriceElement.style.display = 'none';
      }
    }
  }

  getProductData(item) {
    const dataScript = item.querySelector('.product-data');
    if (dataScript) {
      try {
        return JSON.parse(dataScript.textContent);
      } catch (e) {
        console.error('Error parsing product data:', e);
        return {};
      }
    }
    return {};
  }

  formatPrice(priceInCents) {
    return (parseFloat(priceInCents) / 100).toFixed(2);
  }

  // 检查是否需要显示渐变效果
  checkOverflowAndGradient() {
    const wrapper = this.closest('.new-additional-products-wrapper');
    if (!wrapper) return;

    // 检查内容是否产生滚动
    const scrollHeight = this.scrollHeight;
    const clientHeight = this.clientHeight;
    const hasVerticalScroll = scrollHeight > clientHeight;
    
    if (hasVerticalScroll) {
      wrapper.classList.add('show-gradient');
    } else {
      wrapper.classList.remove('show-gradient');
    }
  }

  // 获取所有选中的产品信息
  getSelectedProducts() {
    const selectedItems = this.querySelectorAll('.new-additional-product-item.selected');
    return Array.from(selectedItems).map(item => {
      const productData = this.getProductData(item);
      const variantSelector = item.querySelector('.product-variant-selector');
      const variantSelect = (variantSelector && variantSelector.classList.contains('hidden')) ? null : item.querySelector('.variant-select');
      const selectedVariantId = variantSelect ? variantSelect.value : null;
      
      return {
        productId: productData.id,
        variantId: selectedVariantId,
        productData: productData
      };
    });
  }
}

// 注册自定义元素
if (!window.customElements.get('new-additional-products')) {
  customElements.define('new-additional-products', NewAdditionalProducts);
}

// Slideshow add to cart 自定义元素
class SlideshowAddToCart extends HTMLElement {
  constructor() {
    super();
    this.variantId = this.getAttribute('variant-id');
    this.quantity = parseInt(this.getAttribute('quantity')) || 1;
    this.isLoading = false;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    // 为整个元素绑定点击事件
    this.addEventListener('click', (e) => {
      // 阻止轮播图控制按钮的冲突
      if (e.target.closest('.slideshow__controls') || 
          e.target.closest('button[is="prev-button"]') || 
          e.target.closest('button[is="next-button"]') ||
          e.target.closest('.numbered-dots') ||
          e.target.closest('.stretching-dots')) {
        return;
      }
      
      e.preventDefault();
      e.stopPropagation();
      this.handleAddToCart();
    });
  }

  async handleAddToCart() {
    if (this.isLoading || !this.variantId) {
      return;
    }

    this.isLoading = true;

    try {
      const formData = {
        'items': [{
          'id': parseInt(this.variantId),
          'quantity': this.quantity
        }]
      };

      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // 显示购物车抽屉
      const event = new CustomEvent("cart:show");
      document.dispatchEvent(event);
      document.dispatchEvent(new CustomEvent("cart:refresh"));

    } catch (error) {
      console.error('Error adding to cart:', error);
    } finally {
      this.isLoading = false;
    }
  }
}

if (!window.customElements.get('slideshow-add-to-cart')) {
  customElements.define('slideshow-add-to-cart', SlideshowAddToCart);
}

class ImageLinkBlocksCarousel extends HTMLElement {
  constructor() {
    super();
    this._swiper = null;
  }
  connectedCallback() {
    this._initSwiper();
  }
  disconnectedCallback() {
    if (this._swiper && this._swiper.destroy) {
      this._swiper.destroy(true, true);
      this._swiper = null;
    }
  }
  _initSwiper() {
    const container = this.querySelector('.dev-image-link-swiper');
    if (!container || typeof Swiper === 'undefined') return;

    const isPhone = window.innerWidth <= 767;

    const pcShowNum = parseFloat(this.getAttribute('pc-show-num'));
    const h5ShowNum = parseFloat(this.getAttribute('h5-show-num'));
    const pcGap = parseInt(this.getAttribute('pc-picture-gap'));
    const h5Gap = parseInt(this.getAttribute('h5-picture-gap'));
    const interval = parseInt(this.getAttribute('carousel-interval'));
    const closeCarousel = this.getAttribute('close-carousel') === 'true';

    const slidesPerView = isPhone ? (isNaN(h5ShowNum) ? 1 : h5ShowNum) : (isNaN(pcShowNum) ? 1 : pcShowNum);
    const spaceBetween = isPhone ? (isNaN(h5Gap) ? 0 : h5Gap) : (isNaN(pcGap) ? 0 : pcGap);

    const config = {
      slidesPerView: slidesPerView,
      spaceBetween: spaceBetween,
      loop: true,
      grabCursor: true,
    };

    if (!closeCarousel) {
      config.autoplay = {
        delay: isNaN(interval) ? 4000 : interval,
        disableOnInteraction: false,
      };
    }

    this._swiper = new Swiper(container, config);
  }
}

if (!window.customElements.get('image-link-blocks-carousel')) {
  customElements.define('image-link-blocks-carousel', ImageLinkBlocksCarousel);
}

// 自定义：折扣码复制横幅
class DiscountCodeBanner extends HTMLElement {
  constructor() {
    super();
    this._copyBtn = null;
    this._handleCopy = this._handleCopy.bind(this);
  }

  connectedCallback() {
    this._copyBtn = this.querySelector('.discount-banner__copy-btn');
    if (this._copyBtn) {
      this._copyBtn.addEventListener('click', this._handleCopy);
    }
  }

  disconnectedCallback() {
    if (this._copyBtn) {
      this._copyBtn.removeEventListener('click', this._handleCopy);
    }
  }

  async _handleCopy(event) {
    const btn = event.currentTarget;
    const discountCode = btn.getAttribute('data-discount-code');
    
    if (!discountCode) return;

    try {
      // 尝试使用现代 Clipboard API
      await navigator.clipboard.writeText(discountCode);
      this._showCopiedState(btn);
    } catch (err) {
      // 降级方案：使用 textarea 方法
      this._fallbackCopy(discountCode, btn);
    }
  }

  _fallbackCopy(text, btn) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      const successful = document.execCommand('copy');
      if (successful) {
        this._showCopiedState(btn);
      } else {
        console.error('Copy command failed');
      }
    } catch (err) {
      console.error('Failed to copy:', err);
    }
    
    document.body.removeChild(textArea);
  }

  _showCopiedState(btn) {
    // 添加 copied 状态
    btn.classList.add('copied');
    
    // 2.5秒后移除 copied 状态
    setTimeout(() => {
      btn.classList.remove('copied');
    }, 2500);
  }
}

if (!window.customElements.get('discount-code-banner')) {
  customElements.define('discount-code-banner', DiscountCodeBanner);
}

class OfpPrice extends HTMLElement {
  constructor() {
    super();
    this._onScroll = this._onScroll.bind(this);
    this._modalCalled = false;
    this._onGlobalBeginCountdown = this._onGlobalBeginCountdown.bind(this);
    this._countdownRAF = null;
    this._countdownEndTime = null;
    this._hasTriggeredModal = 0;
  }
  connectedCallback() {
    this._cacheEls();
    this._installments = parseInt(this.getAttribute('data-installments')) || 0;
    this._price = this._safeParseMoney(this.getAttribute('data-price'));
    this._comparePrice = this._safeParseMoney(this.getAttribute('data-compare-price'));
    this._savings = this._safeParseMoney(this.getAttribute('data-savings')) || 0;
    this._countdownMinutes = parseInt(this.getAttribute('data-countdown-minutes')) || 0;
    this._countdownLabel = this.getAttribute('data-countdown-label') || '';
    // 从 Local Storage 读取 modal 触发状态
    const productHandle = this._getProductHandle();
    if (productHandle) {
      const storageKey = productHandle + ' hasTriggeredModal';
      try {
        const storedValue = localStorage.getItem(storageKey);
        if (storedValue !== null) {
          this._hasTriggeredModal = parseInt(storedValue) || 0;
        }
      } catch (e) {
        console.error('Failed to read from localStorage:', e);
      }
    }
    
    this.addEventListener('ofp:switch-to-final', () => this._switchToFinal());
    this.addEventListener('ofp:begin-countdown', (e) => this.beginCountdown((e && e.detail) || {}));
    document.addEventListener('ofp:begin-countdown', this._onGlobalBeginCountdown);
    window.addEventListener('scroll', this._onScroll, { passive: true });
    window.addEventListener('resize', this._onScroll);
    setTimeout(this._onScroll, 0);
  }
  disconnectedCallback() {
    window.removeEventListener('scroll', this._onScroll);
    window.removeEventListener('resize', this._onScroll);
    document.removeEventListener('ofp:begin-countdown', this._onGlobalBeginCountdown);
    if (this._countdownRAF) {
      cancelAnimationFrame(this._countdownRAF);
      this._countdownRAF = null;
    }
  }
  triggerModal() {
    const event = new CustomEvent("open-coupon-modal");
    const modal = document.querySelector('script-trigger-modal[listen-event="open-coupon-modal"]');
    modal.dispatchEvent(event);
    
    // 保存到 Local Storage
    const productHandle = this._getProductHandle();
    if (productHandle) {
      const storageKey = productHandle + ' hasTriggeredModal';
      try {
        localStorage.setItem(storageKey, '1');
        this._hasTriggeredModal = 1;
      } catch (e) {
        console.error('Failed to write to localStorage:', e);
      }
    }
  }
  _getProductHandle() {
    // 从 URL 中提取 product handle
    // 例如: http://127.5.3.5:9292/products/deerrun-plus-walkingpad-treadmill
    // 返回: deerrun-plus-walkingpad-treadmill
    const pathParts = window.location.pathname.split('/');
    const productsIndex = pathParts.indexOf('products');
    if (productsIndex !== -1 && pathParts.length > productsIndex + 1) {
      return pathParts[productsIndex + 1];
    }
    return null;
  }
  _cacheEls() {
    this.currentPriceEl = this.querySelector('.current-price');
    this.compareAtEl = this.querySelector('.compare-at-price');
    this.badgeEl = this.querySelector('.new-price-badge');
    this.installmentEl = this.querySelector('.installment-price');
    this.countdownLabelEl = this.querySelector('.countdown-label');
    this.countdownTimerEl = this.querySelector('.countdown-timer');
    this.countdownContainerEl = this.querySelector('.offer-countdown');
  }
  beginCountdown(options = {}) {
    if (!this.countdownTimerEl) return;
    
    // 获取倒计时分钟数和标签
    const minutes = typeof options.minutes === 'number' ? options.minutes : (parseInt(this._countdownMinutes) || 0);
    const label = options.label != null ? String(options.label) : (this._countdownLabel || '');
    
    // 设置标签文本
    if (this.countdownLabelEl && label) {
      this.countdownLabelEl.textContent = label;
    }
    
    // 如果分钟数无效，显示 00:00:00
    if (!minutes || minutes <= 0) {
      this.countdownTimerEl.textContent = '00 : 00 : 00';
      return;
    }
    
    // 清除旧的倒计时
    if (this._countdownRAF) {
      cancelAnimationFrame(this._countdownRAF);
      this._countdownRAF = null;
    }
    
    // 计算结束时间
    this._countdownEndTime = Date.now() + minutes * 60 * 1000;
    
    // 补零函数
    const pad = (n) => String(n).padStart(2, '0');
    
    // 更新倒计时显示
    const updateCountdown = () => {
      const remainMs = Math.max(0, this._countdownEndTime - Date.now());
      const totalSec = Math.floor(remainMs / 1000);
      
      const hours = Math.floor(totalSec / 3600);
      const minutes = Math.floor((totalSec % 3600) / 60);
      const seconds = totalSec % 60;
      
      this.countdownTimerEl.textContent = `${pad(hours)} : ${pad(minutes)} : ${pad(seconds)}`;
      
      // 如果倒计时未结束，继续下一帧
      if (remainMs > 0) {
        this._countdownRAF = requestAnimationFrame(updateCountdown);
      } else {
        this._countdownRAF = null;
        // 倒计时结束，隐藏倒计时容器
        if (this.countdownContainerEl) {
          this.countdownContainerEl.classList.add('hidden');
        }
      }
    };
    
    // 立即执行一次并开始循环
    updateCountdown();
  }

  _onGlobalBeginCountdown(e) {
    const detail = (e && e.detail) || {};
    const sectionId = this.getAttribute('data-section-id');
    if (!detail.sectionId || detail.sectionId === sectionId) {
      this.countdownContainerEl.classList.remove('hidden');
      this.beginCountdown(detail);
    }
  }
  _onScroll() {
    if (this._modalCalled || !this.currentPriceEl) return;
    const rect = this.currentPriceEl.getBoundingClientRect();
    const centerY = window.innerHeight / 2;
    const centerVisible = rect.top - 100 <= centerY;
    if(this._hasTriggeredModal === 0) { // 因为centerVisible值不稳定，所以不能&&一起判断
      if (centerVisible) {
        this._modalCalled = true;
        try { this.triggerModal(); } catch (e) {}
      }
    } else {
      this._switchToFinal();
    }
  }
  _switchToFinal() {
    if (!this.currentPriceEl) return;
    const fromCurrent = this._getDisplayedNumber(this.currentPriceEl);
    if (this._price != null) {
      this._animateMoney(this.currentPriceEl, fromCurrent, this._price, { prefix: '$' });
    }
    if (this.compareAtEl) {
      this.compareAtEl.classList.remove('hidden');
    }
    if (this.badgeEl) {
      const badgeFrom = this._extractNumberFromText(this.badgeEl.textContent);
      this.badgeEl.style.marginTop = '0px';
      this._animateMoney(this.badgeEl, badgeFrom, this._savings, { prefix: '$', suffix: ' OFF', decimals: 0 });
    }
    if (this.installmentEl) {
      const fromInstallment = this._getDisplayedNumber(this.installmentEl);
      const targetInstallment = (this._installments > 0 && this._price != null)
        ? Math.round((this._price * 100) / this._installments) / 100
        : (this._price != null ? this._price : fromInstallment);
      const hasMo = /\/mo\b/.test(this.installmentEl.textContent);
      this._animateMoney(this.installmentEl, fromInstallment, targetInstallment, { prefix: '$', suffix: hasMo ? '/mo' : '' });
    }
  }
  _safeParseMoney(val) {
    if (val == null || val === '' || val === 'null' || val === 'undefined') return null;
    const num = parseFloat(val);
    if (isNaN(num)) return null;
    return num / 100;
  }
  _getDisplayedNumber(el) {
    const text = (el && el.textContent ? el.textContent : '').replace(/[^\d.,-]/g, '').replace(/,/g, '');
    const n = parseFloat(text);
    return isNaN(n) ? 0 : n;
  }
  _extractNumberFromText(text) {
    if (!text) return 0;
    const t = String(text).replace(/[^\d.,-]/g, '').replace(/,/g, '');
    const n = parseFloat(t);
    return isNaN(n) ? 0 : n;
  }
  _formatMoney(val, decimals = 2) {
    const n = typeof val === 'number' ? val : parseFloat(val) || 0;
    return n.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
  }
  _animateMoney(el, from, to, opts = {}) {
    const prefix = opts.prefix || '';
    const suffix = opts.suffix || '';
    const decimals = Number.isInteger(opts.decimals) ? opts.decimals : 2;
    if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
      el.textContent = prefix + this._formatMoney(to, decimals) + suffix;
      return;
    }
    const start = performance.now();
    const duration = 700;
    const animate = (now) => {
      const p = Math.min(1, (now - start) / duration);
      const val = from + (to - from) * p;
      el.textContent = prefix + this._formatMoney(val, decimals) + suffix;
      if (p < 1) requestAnimationFrame(animate);
    };
    requestAnimationFrame(animate);
  }
}

if (!window.customElements.get('ofp-price')) {
  customElements.define('ofp-price', OfpPrice);
}

// 顶部固定锚点条 - 单个锚点项
//! 该功能，需要注意的是稳定性处理，避免：运营填入的单个信息错误，执行代码报错，继而导致整个锚点条top值未设置上。
class HeaderAnchorItem extends HTMLElement {
  constructor() {
    super();
    this.selectorStr = this.getAttribute("selector-str");
    this.nthDom = parseInt(this.getAttribute("nth-dom")) || 1;
    this.rewriteId = this.getAttribute("rewrite-id");
    this.headerAnchorContainer = this.closest('header-anchor-container');
    this.targetDom = null; // 目标dom元素
    this.targetDomIdAttr = ""; // 目标dom元素的id值
  }
  connectedCallback() {
    this.init();
  }
  init() {
    this.targetDom = this.getTargetDom();
    if (!this.targetDom) {
      return;
    }
    
    if (this.rewriteId) {
      this.rewriteDomId();
    }
    
    // 获取并存储目标DOM的id属性值
    this.targetDomIdAttr = this.targetDom.getAttribute("id") || "";
    
    this.rewriteAEle();
  }

  getTargetDom() {
    try {
      if (this.nthDom - 1 < 0) return null;
      
      // 分两步处理：先查询所有元素，再获取指定索引的元素
      const allElements = document.querySelectorAll(`${this.selectorStr}`);
      if (!allElements || allElements.length === 0) return null;
      
      const targetDom = allElements[this.nthDom - 1];
      return targetDom || null;
    } catch (error) {
      console.error('Error in getTargetDom:', error);
      return null;
    }
  }

  rewriteDomId() {
    this.targetDom.setAttribute('id', this.rewriteId);
  }

  rewriteAEle() {
    const aEle = this.querySelector("a");
    const targetDomId = this.targetDom.getAttribute("id");
    if (!aEle || !targetDomId) {
      return;
    }
    aEle.setAttribute("href", `#${targetDomId}`);
  }
}

if (!window.customElements.get("header-anchor-item")) {
  customElements.define("header-anchor-item", HeaderAnchorItem);
}

// 顶部固定锚点条 - 容器（负责滚动追踪和固定定位）
//! 该功能，需要注意的是稳定性处理，避免：运营填入的单个信息错误，执行代码报错，继而导致整个锚点条top值未设置上。
class HeaderAnchorContainer extends HTMLElement {
  constructor() {
    super();
    this.hadFixedTopClassArr = this.getAttribute("had-fixed-top-class-arr");
    this.dynamicFixedTopSelectorArr = this.getAttribute("dynamic-fixed-top-selector-arr");
    this.observer = null;
  }
  connectedCallback() {
    this.init();
  }
  init() {
    this.setupScrollTracking();
    this.setFixedTopPosition();
    this.setupDynamicElementObserver();
  }
  
  /* 监听动态插件元素的出现，并重新计算top值 */
  setupDynamicElementObserver() {
    if (!this.dynamicFixedTopSelectorArr) return;
    
    const selectorArr = this.dynamicFixedTopSelectorArr.split(',').map(s => s.trim()).filter(Boolean);
    if (selectorArr.length === 0) return;
    
    // 使用MutationObserver监听DOM变化
    this.observer = new MutationObserver(() => {
      // 检查是否有配置的动态元素出现
      const hasDynamicElements = selectorArr.some(selector => {
        return document.querySelector(selector) !== null;
      });
      
      if (hasDynamicElements) {
        // 重新计算top值
        this.setFixedTopPosition();
      }
    });
    
    // 开始观察整个document的子树变化
    this.observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    // 初始检查一次
    setTimeout(() => {
      const hasDynamicElements = selectorArr.some(selector => {
        return document.querySelector(selector) !== null;
      });
      if (hasDynamicElements) {
        this.setFixedTopPosition();
      }
    }, 500);
  }
  
  disconnectedCallback() {
    // 清理observer
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  /* 设置滚动追踪(当滚动到某个section时，对应的锚点项会高亮) */
  setupScrollTracking() {
    const allItems = Array.from(this.querySelectorAll('header-anchor-item'));
    
    // 获取所有目标元素
    const targetElements = allItems.map(item => {
      try {
        const selectorStr = item.getAttribute("selector-str");
        const nthDom = parseInt(item.getAttribute("nth-dom")) || 1;
        const elements = document.querySelectorAll(selectorStr);
        return elements[nthDom - 1];
      } catch (error) {
        console.error('Error querying selector in setupScrollTracking:', error);
        return null;
      }
    }).filter(Boolean);

    const calculateActive = () => {
      const viewportHeight = window.innerHeight;
      // 屏幕底部上方30%的位置
      const triggerPoint = viewportHeight * 0.6; // 底部上方30% = 从顶部算70%
      
      let currentId = '';
      
      // 找到当前滚动位置对应的section
      // 从后往前遍历，找到第一个顶部位置在触发点之上的元素
      for (let i = targetElements.length - 1; i >= 0; i--) {
        const element = targetElements[i];
        const rect = element.getBoundingClientRect();
        const elementTop = rect.top;
        
        // 如果元素顶部已经到达或超过触发点（在触发点上方）
        if (elementTop <= triggerPoint) {
          currentId = element.getAttribute('id');
          break;
        }
      }

      // 更新所有链接的active状态
      allItems.forEach((item) => {
        item.classList.remove('active');
        if (item.querySelector('a')?.getAttribute('href')?.substring(1) === currentId) {
          item.classList.add('active');
        }
      });
    };

    window.addEventListener('scroll', calculateActive);
    calculateActive();
  }

  setFixedTopPosition() {
    const section = this.closest('[id^="shopify-section-"]');
    if (!section) return;

    let topValue = 0;
    
    // 计算hadFixedTopClassArr的高度
    if (this.hadFixedTopClassArr) {
      const classArr = this.hadFixedTopClassArr.split(',').map(c => c.trim()).filter(Boolean);
      topValue += classArr.reduce((prev, item) => {
        let height = 0;
        const element = document.querySelector(item);
        if (element) {
          height = element.clientHeight;
        }
        return prev + height;
      }, 0);
    }
    
    // 计算dynamicFixedTopSelectorArr的高度
    if (this.dynamicFixedTopSelectorArr) {
      const dynamicArr = this.dynamicFixedTopSelectorArr.split(',').map(s => s.trim()).filter(Boolean);
      topValue += dynamicArr.reduce((prev, selector) => {
        let height = 0;
        const element = document.querySelector(selector);
        if (element) {
          height = element.clientHeight;
        }
        return prev + height;
      }, 0);
    }

    section.style.top = topValue + 'px';
  }
}

if (!window.customElements.get("header-anchor-container")) {
  customElements.define("header-anchor-container", HeaderAnchorContainer);
}

// Custom: Tab Product Showcase Logic
class ProductTabs extends HTMLElement {
  constructor() {
    super();
    this.updateIndicator = this.updateIndicator.bind(this);
  }

  connectedCallback() {
    this.tabs = this.querySelectorAll('.tab-nav-item');
    this.panels = this.querySelectorAll('.tab-panel');
    this.indicator = this.querySelector('.tab-indicator');
    
    // Initialize indicator position
    const initialActive = this.querySelector('.tab-nav-item.active');
    if (initialActive) {
      // Use requestAnimationFrame and setTimeout to ensure accurate layout
      requestAnimationFrame(() => this.updateIndicator(initialActive));
      setTimeout(() => this.updateIndicator(initialActive), 100);
    }

    this.tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        // Remove active class from all
        this.tabs.forEach(t => t.classList.remove('active'));
        this.panels.forEach(p => p.classList.remove('active'));

        // Add active to clicked
        tab.classList.add('active');
        
        // Update indicator position
        this.updateIndicator(tab);

        const targetId = tab.getAttribute('data-tab-target');
        const targetPanel = document.getElementById(targetId);
        if (targetPanel) {
            targetPanel.classList.add('active');
            // Trigger resize event to ensure scroll area recalculates if needed
            window.dispatchEvent(new Event('resize'));
        }
      });
    });

    // Handle resize
    window.addEventListener('resize', () => {
      const active = this.querySelector('.tab-nav-item.active');
      if (active) this.updateIndicator(active);
    });
  }

  updateIndicator(activeTab) {
    if (!activeTab || !this.indicator) return;
    this.indicator.style.width = `${activeTab.offsetWidth}px`;
    this.indicator.style.left = `${activeTab.offsetLeft}px`;
  }
}

if (!window.customElements.get("product-tabs")) {
  customElements.define("product-tabs", ProductTabs);
}

// 倒计时自定义元素
class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.totalSeconds = 0;
    this.intervalId = null;
    this.isRunning = false;
  }

  connectedCallback() {
    this.init();
    this.startCountdown();
  }

  disconnectedCallback() {
    this.stopCountdown();
  }

  init() {
    // 从属性中获取配置
    const minutes = parseInt(this.getAttribute('minutes')) || 0;
    const seconds = parseInt(this.getAttribute('seconds')) || 0;
    this.totalSeconds = (minutes * 60) + seconds;
    
    // 获取DOM元素
    this.minutesElement = this.querySelector('.countdown-minutes');
    this.secondsElement = this.querySelector('.countdown-seconds');
    
    // 初始化显示
    this.updateDisplay();
  }

  startCountdown() {
    if (this.isRunning || this.totalSeconds <= 0) {
      return;
    }
    
    this.isRunning = true;
    this.intervalId = setInterval(() => {
      this.totalSeconds--;
      this.updateDisplay();
      
      if (this.totalSeconds <= 0) {
        this.stopCountdown();
        this.onCountdownEnd();
      }
    }, 1000);
  }

  stopCountdown() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
    this.isRunning = false;
  }

  updateDisplay() {
    const minutes = Math.floor(this.totalSeconds / 60);
    const seconds = this.totalSeconds % 60;
    
    if (this.minutesElement) {
      this.minutesElement.textContent = this.formatTime(minutes);
    }
    
    if (this.secondsElement) {
      this.secondsElement.textContent = this.formatTime(seconds);
    }
  }

  formatTime(time) {
    return time.toString().padStart(2, '0');
  }

  onCountdownEnd() {
    // 倒计时结束时的处理
    this.classList.add('countdown-ended');
    
    // 触发自定义事件
    this.dispatchEvent(new CustomEvent('countdown-end', {
      detail: {
        element: this
      }
    }));
    
    // 可以在这里添加倒计时结束后的逻辑
    // 例如：重新开始倒计时、隐藏元素等
    setTimeout(() => {
      this.restartCountdown();
    }, 1000);
  }

  restartCountdown() {
    // 重新获取配置并重启倒计时
    const minutes = parseInt(this.getAttribute('minutes')) || 0;
    const seconds = parseInt(this.getAttribute('seconds')) || 0;
    this.totalSeconds = (minutes * 60) + seconds;
    this.classList.remove('countdown-ended');
    this.updateDisplay();
    this.startCountdown();
  }

  // 公共方法：手动设置倒计时
  setCountdown(minutes, seconds = 0) {
    this.stopCountdown();
    this.totalSeconds = (minutes * 60) + seconds;
    this.updateDisplay();
    this.startCountdown();
  }

  // 公共方法：获取剩余时间
  getRemainingTime() {
    return {
      total: this.totalSeconds,
      minutes: Math.floor(this.totalSeconds / 60),
      seconds: this.totalSeconds % 60
    };
  }
}

// 注册倒计时自定义元素
if (!window.customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer);
}

// Custom: Chat Widget Trigger
class ChatWidgetTrigger extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
    this.pollInterval = null;
    this.pollStartTime = 0;
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick);
    
    // 检查容器是否已存在
    const container = document.querySelector('body > #chat-widget-container');
    if (container) {
      this.startPolling();
    } else {
      this.initObserver();
    }
  }

  handleClick() {
    try {
      if (typeof LiveChatWidget !== 'undefined') {
        // 1. 先添加 class 让 CSS 使得容器可见 (opacity: 1)
        document.body.classList.add('livechat-open');
        
        // 2. 紧接着调用 API 打开聊天窗
        // 使用 requestAnimationFrame 确保 CSS 渲染周期已介入，虽然通常直接调用也行
        requestAnimationFrame(() => {
            LiveChatWidget.call('maximize');
        });
      }
    } catch (error) {
      console.error("尝试打开 LiveChat 失败:", error);
    }
  }

  initObserver() {
    this.observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          for (const node of mutation.addedNodes) {
             // 监测 LiveChat 容器被插入 DOM
             if (node.id === 'chat-widget-container') {
               if(this.observer) this.observer.disconnect();
               this.startPolling();
               return;
             }
          }
        }
      }
    });
    
    // 监听 body 子元素变化
    this.observer.observe(document.body, { childList: true });
  }
  
  startPolling() {
     this.pollStartTime = Date.now();
     
     // 立即检查一次
     if (this.checkLiveChatWidget()) return;

     // 轮询检查 LiveChatWidget 对象是否挂载到 window
     this.pollInterval = setInterval(() => {
        if (this.checkLiveChatWidget()) {
           clearInterval(this.pollInterval);
           return;
        }
        
        // 超时停止（4秒）
        if (Date.now() - this.pollStartTime > 4000) {
           clearInterval(this.pollInterval);
        }
     }, 100);
  }

  checkLiveChatWidget() {
     if (typeof LiveChatWidget !== 'undefined') {
        
        // 当 LiveChat 准备就绪
        LiveChatWidget.on('ready', () => {
           // 1. 显示你的自定义按钮 (移除 hidden 类)
           this.classList.remove('hidden');
           
           // 2. 虽然 CSS 已经隐藏了它，但我们仍需调用 hide API
           // 作用：告诉 LiveChat 内部逻辑“现在是隐藏状态”，防止它发出弹窗提示音或误判
           LiveChatWidget.call('hide');
        });

        // 监听状态变化（处理用户点击关闭/最小化按钮）
        LiveChatWidget.on('visibility_changed', (data) => {
           if (data.visibility === 'minimized') {
               // 1. 移除 body 类 -> CSS 瞬间将 opacity 设为 0 (解决关闭时的闪烁)
               document.body.classList.remove('livechat-open');
               
               // 2. 同步 API 状态，保持逻辑一致
               LiveChatWidget.call('hide');
           }
        });
        
        return true;
     }
     return false;
  }
  
  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    if (this.observer) this.observer.disconnect();
    if (this.pollInterval) clearInterval(this.pollInterval);
  }
}

// 注册 Web Component
if (!window.customElements.get('chat-widget-trigger')) {
  customElements.define('chat-widget-trigger', ChatWidgetTrigger);
}